import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import { useAuth } from '../contexts/AuthContext';
import { authSheetVisibleAtom } from '../atoms';

/**
 * Hook that provides a function to check if user is authenticated.
 * If not authenticated, it opens the auth bottom sheet.
 * Returns true if authenticated, false otherwise.
 */
export function useRequireAuth() {
  const { user } = useAuth();
  const setAuthSheetVisible = useSetAtom(authSheetVisibleAtom);

  const requireAuth = useCallback((): boolean => {
    if (!user) {
      setAuthSheetVisible(true);
      return false;
    }
    return true;
  }, [user, setAuthSheetVisible]);

  return { requireAuth, isAuthenticated: !!user };
}
